import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "dt-previewCard__nav" }
const _hoisted_4 = { class: "dt-previewCard__info" }
const _hoisted_5 = { class: "dt-previewCard__nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fpg_nav = _resolveComponent("fpg-nav")!
  const _component_fpg_info = _resolveComponent("fpg-info")!

  return (_openBlock(), _createElementBlock("div", {
    id: $props.item.id,
    class: _normalizeClass(["dt-previewCard", this.isAdaptive ? '' : 'dt-previewCard_adaptive'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["dt-previewCard__promo", {'square': $props.item.card.column2.style.viewMode === 'square'}])
    }, [
      _createVNode(_component_router_link, {
        to: $props.item.getUrl(),
        class: "dt-previewCard__promo-img"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: $props.item.card.column2.image?.value?.url || this.emptyImagePreviewPassport()
          }, null, 8 /* PROPS */, _hoisted_2)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.card.column2.elements, (element) => {
          return (_openBlock(), _createBlock(_component_fpg_nav, {
            element: element,
            item: $props.item,
            buttonBlock: true
          }, null, 8 /* PROPS */, ["element", "item"]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.card.column1.elements, (element) => {
        return (_openBlock(), _createBlock(_component_fpg_info, {
          element: element,
          item: $props.item,
          onApplyFilter: $options.onApplyFilter
        }, null, 8 /* PROPS */, ["element", "item", "onApplyFilter"]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.card.column2.elements, (element) => {
        return (_openBlock(), _createBlock(_component_fpg_nav, {
          element: element,
          item: $props.item
        }, null, 8 /* PROPS */, ["element", "item"]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}